export default __webpack_public_path__ + "static/media/david5.88620c8c.jpg";